import InfoSection from "../../components/careers/InfoSection";
import Hero from "../../components/careers/Hero";
import { NextSeo } from "next-seo";
import { careersPageData } from "../../Layout/seo/PagesBaseData";
import logo from "../../public/cropped-va-law-offices-logo-32x32.png";

const Careers = () => {
  return (
    <>
      <NextSeo
        title={careersPageData.title}
        description={careersPageData.description}
        canonical={careersPageData.url}
        openGraph={{
          url: careersPageData.url,
          title: careersPageData.title,
          description: careersPageData.description,
          images: [
            {
              url: process.env.NEXT_PUBLIC_BASE_URL + logo.src,
              width: logo.width,
              height: logo.height,
              alt: "Vidhigya Associates Logo",
              type: "image/jpeg",
            },
          ],
          site_name: "Vidhigya Associates",
        }}
      />
      <Hero />
      <InfoSection />
    </>
  );
};

export default Careers;
